import { Injector } from "@angular/core";
import { Art57NodeList } from "../../Art57Node/Art57NodeList";
import { ListView } from "../../../Data/ListView";
import { TreeNodeDrugIndicationEntity } from "../Entity/TreeNodeDrugIndicationEntity";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { BaseNode } from "../../BaseNode";
import { environment } from "../../../../../../environments/environment";



export class TreeNodeMedicinalProductsDrugIndication extends Art57NodeList{
    items: any;
    cloningNode: boolean = false;
    constructor(injector: Injector, parent: any, cloningNode:boolean, items: any[]|undefined) {
        super(injector, new ListView(), `Drug Indications (${items?items.length:'-'})`);
        this.parent = parent;
        this.cloningNode = cloningNode;
        this.labelNodeName = 'Drug Indications'
        this.items = items;

        if (this.cloningNode) {
            return;
        }

        for (const item of items || []) {            
            const labelTemplate = item.meddracode.value + ' - ' + item.meddracode.name + ' - Ver. ' + 
                                  injector.get(LookupGetService).retrieveValueFromCache('supportedbacklogmeddraversions', item.meddraversion) + ' - ' +
                                  injector.get(LookupGetService).retrieveValueFromCache('meddraLevel', item.meddralevel);

            this.children?.push(new TreeNodeDrugIndicationEntity(injector,labelTemplate,this,item));
        }
    }

    override getHeaders(): string[] {
        return ['MedDRA Version','MedDRA Level','MedDRA Term','MedDRA Term Name'];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeMedicinalProductsDrugIndication = new TreeNodeMedicinalProductsDrugIndication(this.ioc!,newParent, true, this.items);        
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }   
}